import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementBlock as _createElementBlock, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "flex flex-col flex-1 pb-28 w-full h-full bg-white tw"
};
const _hoisted_2 = {
  class: "flex justify-between items-center"
};
const _hoisted_3 = {
  class: "px-6 w-full tw"
};
const _hoisted_4 = {
  class: "flex flex-row bg-white mb-4"
};
const _hoisted_5 = {
  class: "flex items-center w-4/12"
};
const _hoisted_6 = {
  class: "flex justify-end w-full align-middle"
};
const _hoisted_7 = {
  class: "flex no-print"
};
const _hoisted_8 = {
  class: "flex relative my-1 rounded-md shadow-sm"
};
const _hoisted_9 = {
  class: "flex-1 print:overflow"
};
const _hoisted_10 = {
  class: "inline-block print:inline py-2 min-w-full align-middle"
};
const _hoisted_11 = {
  key: 0,
  class: "m-6 text-xs text-gray-800"
};
const _hoisted_12 = {
  key: 1,
  class: "bar-border-bottom border-gray-200 shadow"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  class: "min-w-full divide-y divide-gray-200"
};
const _hoisted_15 = {
  class: "sticky top-0 py-4 px-6 no-print text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
};
const _hoisted_16 = {
  class: "py-4 px-6 no-print"
};
const _hoisted_17 = {
  class: "fa fa-cog fa-spin"
};
const _hoisted_18 = {
  class: "py-3 px-6"
};
const _hoisted_19 = {
  class: "py-3 px-6"
};
const _hoisted_20 = {
  class: "py-3 px-6"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "py-3 px-6"
};
const _hoisted_23 = {
  class: "py-3 px-6"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = {
  class: "py-3 px-6"
};
const _hoisted_28 = {
  class: "py-3 px-6"
};
const _hoisted_29 = {
  class: "ll-menu dropdown no-print"
};
const _hoisted_30 = {
  class: "dropdown-menu"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "flex flex-row-reverse px-8 py-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_main_header = _resolveComponent("main-header");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  const _component_payments_time_filter_modal = _resolveComponent("payments-time-filter-modal");
  const _component_assign_distributions = _resolveComponent("assign-distributions");
  const _component_LlCheckbox = _resolveComponent("LlCheckbox");
  const _component_LlTooltip = _resolveComponent("LlTooltip");
  const _component_pagination = _resolveComponent("pagination");
  return $setup.loading ? (_openBlock(), _createBlock(_component_loader, {
    key: 0,
    what: 'Payments',
    class: "mt-32"
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_main_header, {
    content: 'Payments',
    isBillingPageTitle: "true"
  })]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("div", _hoisted_7, [_withDirectives(_createVNode(_component_LlSecondaryButton, {
    class: "m-2",
    onClick: _cache[0] || (_cache[0] = $event => $setup.update(null, false))
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Assign to Distribution ", -1)]))]),
    _: 1
  }, 512), [[_vShow, $setup.transactions?.length]]), _withDirectives(_createVNode(_component_LlSecondaryButton, {
    class: "m-2",
    onClick: _cache[1] || (_cache[1] = $event => $setup.removeDistribution())
  }, {
    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Remove from Distribution ", -1)]))]),
    _: 1
  }, 512), [[_vShow, $setup.transactions?.length]])], 512), [[_vShow, $setup.transactions?.length]]), _createVNode(_component_LlSecondaryButton, {
    icon: "mdi-filter",
    variant: "text",
    class: "no-print",
    color: $setup.paymentStore.paymentDefaultFilterChange ? 'primary' : undefined,
    "aria-label": "Filter payments",
    onClick: _cache[2] || (_cache[2] = $event => $setup.distributionNavigationStore.toggleTimeFilterModal(true))
  }, null, 8, ["color"]), $setup.distributionNavigationStore.showTimeFilterModal ? (_openBlock(), _createBlock(_component_payments_time_filter_modal, {
    key: 0
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_cache[13] || (_cache[13] = _createElementVNode("div", {
    class: "flex absolute inset-y-0 left-0 items-center pt-1 pl-3 pointer-events-none",
    "aria-hidden": "true"
  }, [_createElementVNode("svg", {
    class: "mr-3 w-4 h-4 text-gray-400",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
    "clip-rule": "evenodd"
  })])], -1)), _withDirectives(_createElementVNode("input", {
    type: "search",
    name: "search",
    class: "block w-full no-print",
    placeholder: "Search Payments",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.query = $event)
  }, null, 512), [[_vModelText, $setup.query]])])])])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [!$setup.transactions?.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, " No Payments match the filters ")) : (_openBlock(), _createElementBlock("div", _hoisted_12, [$setup.distributionNavigationStore.showAssignDestributionModal ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_assign_distributions, {
    transactions: $setup.transactions,
    me: $setup.me,
    modalService: $props.modalService
  }, null, 8, ["transactions", "me", "modalService"])])) : _createCommentVNode("", true), _createElementVNode("table", _hoisted_14, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_15, [_createVNode(_component_LlCheckbox, {
    modelValue: $setup.checkedAll,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.checkedAll = $event),
    "aria-label": "Select all payments on this page",
    onCheckboxClick: _cache[5] || (_cache[5] = $event => $setup.checkAll($setup.checkedAll))
  }, null, 8, ["modelValue"])]), _cache[14] || (_cache[14] = _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, null, -1)), _createElementVNode("th", {
    class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50",
    onClick: _cache[6] || (_cache[6] = $event => $setup.paymentStore.paymentSort('date'))
  }, " Date "), _createElementVNode("th", {
    class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50",
    onClick: _cache[7] || (_cache[7] = $event => $setup.paymentStore.paymentSort('client'))
  }, " Client "), _createElementVNode("th", {
    class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50",
    onClick: _cache[8] || (_cache[8] = $event => $setup.paymentStore.paymentSort('matter'))
  }, _toDisplayString($setup.me.terms?.Matter), 1), _cache[15] || (_cache[15] = _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Invoice Ids ", -1)), _createElementVNode("th", {
    class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50",
    onClick: _cache[9] || (_cache[9] = $event => $setup.paymentStore.paymentSort('amount'))
  }, " Amount "), _cache[16] || (_cache[16] = _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Distribution ", -1)), _cache[17] || (_cache[17] = _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Status ", -1)), _cache[18] || (_cache[18] = _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 w-px text-xs font-medium text-gray-500 bg-gray-50"
  }, null, -1))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.transactions, (transaction, idx) => {
    return _openBlock(), _createElementBlock("tr", {
      key: idx,
      class: "bg-white divide-y divide-gray-200"
    }, [_createElementVNode("td", _hoisted_16, [_createVNode(_component_LlCheckbox, {
      modelValue: transaction.checked,
      "onUpdate:modelValue": $event => transaction.checked = $event,
      "aria-label": `Select payment from ${transaction.invoices[0]?.client?.label ?? 'client'} on ${_ctx.formatDate(transaction.date)}`,
      onCheckboxClick: _cache[10] || (_cache[10] = $event => $setup.updateMasterCheckbox())
    }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label"])]), _createElementVNode("td", null, [_withDirectives(_createElementVNode("span", _hoisted_17, null, 512), [[_vShow, transaction.saving]])]), _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatDate(transaction.date)), 1), _createElementVNode("td", _hoisted_19, _toDisplayString(transaction.invoices[0]?.client?.label), 1), _createElementVNode("td", _hoisted_20, _toDisplayString(transaction.invoices[0]?.matters[0]?.label), 1), _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transaction.invoices, (invoice, idx) => {
      return _openBlock(), _createElementBlock("span", {
        key: idx,
        class: "cursor-pointer"
      }, [_createElementVNode("a", {
        onClick: $event => $setup.openInvoice(invoice)
      }, _toDisplayString(invoice?.reference) + _toDisplayString(" "), 9, _hoisted_21)]);
    }), 128))]), _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.formatCurrency(transaction.amount)), 1), _createElementVNode("td", _hoisted_23, [_createElementVNode("div", null, [_withDirectives(_createElementVNode("span", null, _toDisplayString(transaction.distribution?.label), 513), [[_vShow, transaction.distribution?.label]]), transaction.distribution?.date ? (_openBlock(), _createElementBlock("span", _hoisted_24, "(" + _toDisplayString(_ctx.formatDate($setup.getShortDateString(transaction.distribution?.date))) + ")", 1)) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", null, [transaction.distributionPayments.length === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transaction.distributionPayments, (payment, idx) => {
      return _openBlock(), _createElementBlock("span", {
        key: idx
      }, _toDisplayString(payment.distribution?.label), 1);
    }), 128))])) : _createCommentVNode("", true), transaction.distributionPayments.length > 1 ? (_openBlock(), _createElementBlock("span", _hoisted_26, [_createVNode(_component_LlTooltip, null, {
      activator: _withCtx(() => [_createElementVNode("span", _hoisted_27, _toDisplayString(transaction.distributionPayments.length), 1)]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transaction.distributionPayments, (payment, idx) => {
        return _openBlock(), _createElementBlock("span", {
          key: idx
        }, [_createTextVNode(_toDisplayString(payment.distribution?.label) + ", ", 1), _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))]);
      }), 128))]),
      _: 2
    }, 1024)])) : _createCommentVNode("", true)], 512), [[_vShow, transaction.distributionPayments]])]), _createElementVNode("td", _hoisted_28, _toDisplayString($setup.getDistributionStatusLabel(transaction?.status)), 1), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_29, [_cache[20] || (_cache[20] = _createElementVNode("span", {
      class: "dropdown-toggle",
      "data-toggle": "dropdown"
    }, [_createElementVNode("i", {
      class: "fa fa-ellipsis-v"
    })], -1)), _createElementVNode("ul", _hoisted_30, [_createElementVNode("li", null, [_createElementVNode("span", {
      class: "menuitem",
      onClick: $event => $setup.openPayment(transaction)
    }, "View Payment in QuickBooks", 8, _hoisted_31)]), _createElementVNode("li", null, [_createElementVNode("span", {
      class: _normalizeClass({
        menuitemdisable: transaction.distribution?.status === 'Distributed',
        menuitem: transaction.distribution?.status !== 'Distributed'
      }),
      onClick: $event => $setup.update([transaction], transaction.distribution?.status === 'Distributed')
    }, "Assign to Distribution", 10, _hoisted_32)]), _createElementVNode("li", null, [_createElementVNode("span", {
      class: _normalizeClass({
        menuitemdisable: transaction.distribution?.status === 'Distributed',
        menuitem: transaction.distribution?.status !== 'Distributed'
      }),
      onClick: $event => $setup.removeDistribution(transaction)
    }, "Remove from Distribution", 10, _hoisted_33)]), _createElementVNode("li", null, [_createElementVNode("span", {
      class: "menuitem",
      onClick: $event => $setup.showAllocation(transaction)
    }, "Allocation Detail", 8, _hoisted_34)])])])])]);
  }), 128))])])]))])]), _createElementVNode("div", _hoisted_35, [_withDirectives(_createVNode(_component_pagination, {
    "total-pages": $setup.paymentStore.paymentsTotalPages,
    totalItems: $setup.paymentStore.paymentsList?.pagination?.total || 0,
    offset: $setup.paymentStore.paymentsList?.pagination?.offset || 0,
    "per-page": $setup.paymentStore.paymentsList.perPage,
    "current-page": $setup.paymentStore.paymentsList.currentPage,
    "open-direction": 'top',
    onPagechanged: $setup.paymentStore.onPaymentsPageChange
  }, null, 8, ["total-pages", "totalItems", "offset", "per-page", "current-page", "onPagechanged"]), [[_vShow, $setup.paymentStore.paymentsTotalPages > 1]])])]));
}